import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import HttpClient from '../../../services/HttpClient'

export const createAdventure = createAsyncThunk('adventure/create', async (data, { rejectWithValue }) => {
  try {
    const httpClient = HttpClient()
    const response = await httpClient.post('/api/v1/adventure/create', data)
    return response.data
  } catch (error) {
    // El HttpClient ya maneja el formato de errores
    return rejectWithValue(error.message || 'Failed to create adventure')
  }
})

const createAdventureSlice = createSlice({
  name: 'createAdventure',
  initialState: {
    loading: false,
    error: null,
    adventure: null,
    success: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = false
    },
    resetState: (state) => {
      state.loading = false
      state.error = null
      state.adventure = null
      state.success = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAdventure.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(createAdventure.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const payload = action.payload
        state.adventure = payload?.data && typeof payload.data === 'object' ? payload.data : payload
        state.success = true
      })
      .addCase(createAdventure.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.success = false
      })
  },
})

export const { clearError, clearSuccess, resetState } = createAdventureSlice.actions

export default createAdventureSlice.reducer
